import React from "react";

const PageHeader = (props) => {
  return (
    <div className="modern-page-header">
      <p>MANAGEMENT CONSOLE</p>
      <h2>{props.pageTitle}</h2>
    </div>
  );
};

export default PageHeader;
